module.exports = __webpack_public_path__ + "static/media/pic5.e54217a0.jpg";